import { render } from "./EditorUploadFiles.vue?vue&type=template&id=7c0ecca5&ts=true"
import script from "./EditorUploadFiles.vue?vue&type=script&lang=ts"
export * from "./EditorUploadFiles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__